import { render } from "./preregistroTarjetahabientes.vue?vue&type=template&id=7ba1bb77"
import script from "./preregistroTarjetahabientes.vue?vue&type=script&lang=js"
export * from "./preregistroTarjetahabientes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__